/**
 * Generated by orval v8.7.0 🍺
 * Do not edit manually.
 * K3X API
 * The K3X API description
 * OpenAPI spec version: 1.0
 */

export type ListSuperadminActivityEntityType = typeof ListSuperadminActivityEntityType[keyof typeof ListSuperadminActivityEntityType];


export const ListSuperadminActivityEntityType = {
  lead: 'lead',
  contact: 'contact',
  organization: 'organization',
  user: 'user',
  twilio_message: 'twilio_message',
  twilio_call: 'twilio_call',
  email_message: 'email_message',
  calendar_event: 'calendar_event',
  deal_stage: 'deal_stage',
  custom_field: 'custom_field',
  ai_agent: 'ai_agent',
} as const;
